<template>
    <div class="modal-mask" @click="$emit('fecharModal')">
        <div class="jm margem" style="min-width: 30vw" @click.stop>
            <div class="alinha-centro">
                <h2>
                    Novo pacote de trabalho
                </h2>
            </div>
            <br>
            <div class="grid-2">
                <div>
                    <label>Nome do pacote de trabalho</label>
                    <input v-model="novaEntrega.nome" :required="!novaEntrega.nome" type="text" />
                </div>
                <div>
                    <label>Coordenador</label>
                    <select v-model="novaEntrega.coordenador_id" :required="!novaEntrega.coordenador_id">
                        <option v-for="item in coordenadores" :key="item.id" :value="item.id">
                            {{ item.nomeCompleto || item.usuario_nome }}
                        </option>
                    </select>
                </div>
                <div class="col-2">
                    <label>Entrega a ser alcançada</label>
                    <select v-model="novaEntrega.resultado_id" :required="!novaEntrega.resultado_id">
                        <option v-for="item, index in resultados" :key="item.id" :value="item.id"
                            :title="tituloResultado(item, index)">
                            {{ rotuloResultado(item, index) }}
                        </option>
                    </select>
                </div>
                <div>
                    <label>
                        Data Inicio
                    </label>
                    <input v-model="novaEntrega.dtInicio" type="date" :min="propPcm.dtInicio" required>
                </div>
                <div>
                    <label>
                        Data Fim
                    </label>
                    <input v-model="novaEntrega.dtFim" type="date" :min="novaEntrega.dtInicio || propPcm.dtInicio"
                        required>
                </div>
            </div>
            <div class="submit m-b direita"><button @click="$emit('salvarEntrega', novaEntrega)"
                    :disabled="camposVazios"
                    :title="camposVazios ? 'Preencha os campos destacados!' : ''">Salvar</button>
            </div>
        </div>
    </div>
</template>

<script>
import { rotuloResultado, tituloResultado } from '@/utils/resultado-rotulo';

export default {
    name: 'ModalNovaEntrega',

    data() {
        const resultados = Array.isArray(this.propPcm?.resultados) ? this.propPcm.resultados : []
        const preSelecionado = resultados.find((r) => r.id == this.resultadoSelecionadoId)

        return {
            novaEntrega: {
                status: 'Pendente',
                resultado_id: preSelecionado?.id ?? null,
            }
        }
    },

    props: {
        coordenadores: {
            required: true
        },
        propPcm: {
            default: {},
        },
        resultadoSelecionadoId: {
            type: [Number, String],
            default: null,
        },
    },

    computed: {
        resultados() {
            return Array.isArray(this.propPcm?.resultados) ? this.propPcm.resultados : []
        },
        camposVazios() {
            var campos = ['nome', 'coordenador_id', 'dtInicio', 'dtFim', 'resultado_id']
            return campos.some(item => !this.novaEntrega[item] || this.novaEntrega[item] === '');
        }
    },

    methods: {
        rotuloResultado,
        tituloResultado,
    }
}
</script>

<style scoped></style>